import { ContentRoutes } from '../enums/routes';

export const translatedNames = {
  [ContentRoutes.Routes]: 'Rotas',
  [ContentRoutes.Users]: 'Usuários',
  [ContentRoutes.SuperUsers]: 'Super usuários',
  [ContentRoutes.Roles]: 'Permissões',
  [ContentRoutes.Regionals]: 'Regionais',
  [ContentRoutes.Materials]: 'Materiais',
  [ContentRoutes.Containers]: 'Embalagens',
  [ContentRoutes.Project]: 'Projetos',
  [ContentRoutes.Partner]: 'Parceiros',
  [ContentRoutes.Checklists]: 'Checklists',
  [ContentRoutes.Vehicles]: 'Veículos',
  [ContentRoutes.AccessoryTypes]: 'Tipos de Acessórios',
  [ContentRoutes.VehicleAccessories]: 'Acessórios Veiculares',
  [ContentRoutes.Dispatch]: 'Despachos',
  [ContentRoutes.Drivers]: 'Condutores',
  [ContentRoutes.Trainings]: 'Treinamentos',
  [ContentRoutes.UsersTrainings]: 'Meus treinamentos',
  [ContentRoutes.QRCode]: 'Meus QRCodes',
  [ContentRoutes.Companies]: 'Empresas',
};

export const breadcrumbs = {
  [ContentRoutes.Drivers]: [
    {
      path: '/',
      label: 'Início',
    }, {
      path: `/table/${ContentRoutes.Drivers}`,
      label: translatedNames[ContentRoutes.Drivers],
    },
  ],
  [ContentRoutes.Routes]: [
    {
      path: '/',
      label: 'Início',
    }, {
      path: `/table/${ContentRoutes.Routes}`,
      label: translatedNames[ContentRoutes.Routes],
    },
  ],
  [ContentRoutes.Materials]: [
    {
      path: '/',
      label: 'Início',
    }, {
      path: `/table/${ContentRoutes.Materials}`,
      label: translatedNames[ContentRoutes.Materials],
    },
  ],
  [ContentRoutes.Containers]: [
    {
      path: '/',
      label: 'Início',
    }, {
      path: `/table/${ContentRoutes.Containers}`,
      label: translatedNames[ContentRoutes.Containers],
    },
  ],
  [ContentRoutes.Regionals]: [
    {
      path: '/',
      label: 'Início',
    }, {
      path: `/table/${ContentRoutes.Regionals}`,
      label: translatedNames[ContentRoutes.Regionals],
    },
  ],
  [ContentRoutes.Users]: [
    {
      path: '/',
      label: 'Início',
    }, {
      path: `/table/${ContentRoutes.Users}`,
      label: translatedNames[ContentRoutes.Users],
    },
  ],
  [ContentRoutes.SuperUsers]: [
    {
      path: '/',
      label: 'Início',
    }, {
      path: `/table/${ContentRoutes.SuperUsers}`,
      label: translatedNames[ContentRoutes.SuperUsers],
    },
  ],
  [ContentRoutes.Roles]: [
    {
      path: '/',
      label: 'Início',
    }, {
      path: `/table/${ContentRoutes.Roles}`,
      label: translatedNames[ContentRoutes.Roles],
    },
  ],
  [ContentRoutes.Project]: [
    {
      path: '/',
      label: 'Início',
    }, {
      path: `/table/${ContentRoutes.Project}`,
      label: translatedNames[ContentRoutes.Project],
    },
  ],
  [ContentRoutes.Partner]: [
    {
      path: '/',
      label: 'Início',
    }, {
      path: `/table/${ContentRoutes.Partner}`,
      label: translatedNames[ContentRoutes.Partner],
    },
  ],
  [ContentRoutes.Company]: [
    {
      path: '/',
      label: 'Início',
    },
  ],
  [ContentRoutes.Companies]: [
    {
      path: '/',
      label: 'Início',
    }, {
      path: `/table/${ContentRoutes.Companies}`,
      label: translatedNames[ContentRoutes.Companies],
    },
  ],
  [ContentRoutes.Checklists]: [
    {
      path: '/',
      label: 'Início',
    }, {
      path: `/table/${ContentRoutes.Checklists}`,
      label: translatedNames[ContentRoutes.Checklists],
    },
  ],
  [ContentRoutes.Vehicles]: [
    {
      path: '/',
      label: 'Início',
    }, {
      path: `/table/${ContentRoutes.Vehicles}`,
      label: translatedNames[ContentRoutes.Vehicles],
    },
  ],
  [ContentRoutes.AccessoryTypes]: [
    {
      path: '/',
      label: 'Início',
    }, {
      path: `/table/${ContentRoutes.AccessoryTypes}`,
      label: translatedNames[ContentRoutes.AccessoryTypes],
    },
  ],
  [ContentRoutes.VehicleAccessories]: [
    {
      path: '/',
      label: 'Início',
    }, {
      path: `/table/${ContentRoutes.AccessoryTypes}`,
      label: translatedNames[ContentRoutes.AccessoryTypes],
    },
  ],
  [ContentRoutes.Dispatch]: [
    {
      path: '/',
      label: 'Início',
    }, {
      path: `/table/${ContentRoutes.Dispatch}`,
      label: translatedNames[ContentRoutes.Dispatch],
    },
  ],
  [ContentRoutes.Trainings]: [
    {
      path: '/',
      label: 'Início',
    }, {
      path: `/table/${ContentRoutes.Trainings}`,
      label: translatedNames[ContentRoutes.Trainings],
    },
  ],
  [ContentRoutes.UsersTrainings]: [
    {
      path: '/',
      label: 'Início',
    }, {
      path: `/table/${ContentRoutes.Trainings}`,
      label: translatedNames[ContentRoutes.UsersTrainings],
    },
  ],
  [ContentRoutes.QRCode]: [
    {
      path: '/',
      label: 'Início',
    }, {
      path: `/table/${ContentRoutes.QRCode}`,
      label: translatedNames[ContentRoutes.QRCode],
    },
  ],
};
